module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/063892ef24eec57459ee932cec7e12e5.png";